import { FC, ReactNode } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import AccordionDetails from '@mui/material/AccordionDetails';

import { useAccordionPanel } from 'components/AccordionController';

type Props = Omit<AccordionProps, 'title'> & {
  id: string;
  title?: ReactNode;
  toolbar?: ReactNode;
};

export type SectionWithToolbarProps = Props;

const SectionWithToolbar: FC<Props> = props => {
  const { id, title, toolbar, children, ...rest } = props;
  const [open, handleChange] = useAccordionPanel(id);

  return (
    <Accordion expanded={open} onChange={handleChange} {...rest}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography
          component="div"
          sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          {title}
        </Typography>

        {open && toolbar}
      </AccordionSummary>

      <Divider />

      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default SectionWithToolbar;
